import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import app from './app';
import { reducer as formReducer } from 'redux-form';

const rootReducer = combineReducers({
  router: routerReducer,
  app,
  form: formReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js